import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import * as rosterActionsCreators from '../../../redux/css-admin/roster/operations'
import { connect } from 'react-redux'
import RosterLayout from './RosterLayout'

function RosterContainer(props) {
  return <RosterLayout {...props} />
}

const mapStateToProps = ({ rosterManager }) => {
  return {
    ...rosterManager,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...rosterActionsCreators,
    },
    dispatch,
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RosterContainer)



// WEBPACK FOOTER //
// ./src/containers/css-admin/roster/RosterContainer.js